export enum Visibility {
    Public = "Public",
    Internal = "Internal",
    Private = "Private",
}
